import React, { useRef } from 'react'
import { AdminLoginPresenter } from './admin-login-presenter'
import { adminSignInSchema as loginSchema } from '../../lib/utils/schema'
import { Card, H2, Flex } from '../../lib/components'
import { userServices } from '../../services'
import ReCAPTCHA from 'react-google-recaptcha'
import { useDispatch } from 'react-redux'
import { createConfiguration } from '../../global-state/investor-slice'
import { showBanner } from '../../global-state/banner-slice'
import { useNavigate } from 'react-router-dom'
import { useBreakpoint } from '../../lib/utils/hooks'
import { SM } from '../../lib/utils/constants'
import { getInvestorDataFromSS } from '../../lib/utils/local-storage'
import { EngagementEvents, logCrmEvent } from '../../lib/utils/crmEvents'
import { Role } from '../../lib/types'

const initialValues = {
  adminEmail: '',
  investorEmail: '',
  password: '',
}

const AdminLoginContainer = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const reRef = useRef<ReCAPTCHA>(null)
  const { breakpoint } = useBreakpoint()
  const { authToken, investorData } = getInvestorDataFromSS()

  const handleSubmit_v1 = async (val: any) => {
    const token = await reRef.current?.executeAsync()
    reRef.current?.reset()
    if (!authToken && !investorData) {
      const user = await userServices.adminLoginAsInvestor_v1(
        {
          adminEmail: val.adminEmail?.toLowerCase(),
          email: val.investorEmail?.toLowerCase(),
          password: val.password,
          role: Role.credibilaAdmin,
        },
        { 'g-recaptcha-response': token ? token : '' },
      )
      if (!!user && user.status === 200) {
        dispatch(
          createConfiguration({
            isEmailVerified: user.data.is_verified,
            accountStatus: user.data.account_status,
            ...user.data,
          }),
        )

        dispatch(
          showBanner({
            text: `Logged in successfully as ${val.investorEmail}`,
            variant: 'success-banner',
            duration: 1000,
          }),
        )

        logCrmEvent(
          EngagementEvents.USER_LOGGED_IN_EMAIL,
          { Authorization: user.data.authToken },
          { email: user.data.email },
        )

        navigate('/')
      } else if (!!user && [400, 401, 404].includes(user.status)) {
        dispatch(
          showBanner({
            text: user.data.message || 'Something went wrong! Please try again.',
            variant: 'error-banner',
          }),
        )
      }
    } else {
      dispatch(
        showBanner({
          text: 'You already logged in another tab. Please logout and use another account.',
          variant: 'error-banner',
          duration: 3000,
        }),
      )
    }
  }

  return (
    <Flex variant='column-center'>
      <H2 text={'Login to Client Account'} classes={['mb-48']} />
      <Card classes={breakpoint && breakpoint <= SM ? ['p-24'] : ['p-40']}>
        <AdminLoginPresenter
          initialValues={initialValues}
          validationSchema={loginSchema}
          handleFormSubmit={handleSubmit_v1}
          reRef={reRef}
        />
      </Card>
    </Flex>
  )
}

export { AdminLoginContainer }
